import { Fragment, useEffect, useState } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import PickupStudentMobile from "./pickupStudentMobile";
import PickupStudentWeb from "./pickupStudentWeb";
import { Dialog, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const PickupStudentComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("PickupStudent");
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const { t } = useTranslation();

  const closeModal = () => {
    setIsOpen(false);
    navigate(`/home`, { replace: true });
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const toScanPage = (studentId: string, grade: string) => {
    navigate(`/pickup-student/scan/${studentId}/${grade}`);
  };
  const toQRPage = (studentId: string, grade: string, studentName: string) => {
    navigate(`/pickup-student/create-qr/${studentId}/${grade}/${studentName}`);
  };
  const toBookingPage = () => {
    navigate(`/pickup-student/booking`);
  };
  const toStatusBookingPage = () => {
    navigate("/pickup-student/status");
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Pickup Student",
    });
    if (isBrowser) {
    }
  }, []);
  return (
    <>
      <BrowserView>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="flex flex-row">
                        {/* <img
                          src={helpIcon}
                          alt=""
                          className="text-black mr-2"
                        /> */}
                        {/* <div>{t("DIGITALCARD.help")}</div> */}
                      </div>
                    </Dialog.Title>
                    <div className="rounded-2xl bg-psp-primary mt-3 p-2">
                      Mohon maaf, Fitur ini belum tersedia pada perangkat
                      desktop
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                        onClick={closeModal}
                      >
                        {t("OTHER.back")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <PickupStudentWeb
          toScanPage={toScanPage}
          toBookingPage={toBookingPage}
          toQRPage={toQRPage}
          toStatusBookingPage={toStatusBookingPage}
        ></PickupStudentWeb>
      </BrowserView>
      <MobileView>
        <PickupStudentMobile
          toScanPage={toScanPage}
          toBookingPage={toBookingPage}
          toQRPage={toQRPage}
          toStatusBookingPage={toStatusBookingPage}
        ></PickupStudentMobile>
      </MobileView>
    </>
  );
};

export default PickupStudentComponent;
